<div class="search-backdrop">
  <div class="search-container">
    <div class="liquid-blob"></div>

    <div class="p-24">
      <div class="row">
        <div class="col-10">
          <mat-form-field appearance="outline" color="primary" class="hide-hint w-100">
            <input matInput placeholder="Search here" [value]="searchText()" (input)="onSearchTextChange($event)" />
          </mat-form-field>
        </div>
        <div class="col-2 d-flex justify-content-end">
          <app-mat3-button
            variant="icon"
            icon="mdi:close"
            [iconSize]="18"
            class="d-flex justify-content-center"
            ariaLabel="Close"
            (buttonClick)="dialogRef.close()">
          </app-mat3-button>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
    <mat-dialog-content class="mat-typography search-dialog">
      <h4 class="f-s-18 f-w-600 m-b-16">Quick Page Links</h4>

      @for(item of navItemsData(); track item.id) {
        <span>
          @for(child of item.children ; track child.route){
            @if(child.displayName) {
              <a [routerLink]="[child.route]" mat-dialog-close class="p-y-12 text-decoration-none d-block">
                <h5 class="f-s-14 f-w-500 d-block m-0">
                  {{ child.displayName }}
                </h5>
                <span class="f-s-12">{{ child.route }}</span>
              </a>
            } }
        </span>
      }
    </mat-dialog-content>
  </div>
</div>